import styled from 'styled-components'

import { BridgeLink } from '@webapp/core/components/BridgeLink'
import { baseBreadcrumbStyles } from './BaseBreadcrumbStyles'

export const BreadcrumbLinkStyled = styled(BridgeLink)`
  ${baseBreadcrumbStyles}
`
